import React, { FC } from 'react';
import Form from 'components/Form';

import { OllaPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Olla: FC<OllaPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Olla;
